import { Component, ViewChild } from '@angular/core';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { BookingsExtendsComponent } from 'src/app/booking/bookings/bookings-extends/bookings-extends.component';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import { SearchComponent } from 'src/app/components/search/search.component';

@Component({
  selector: 'app-schedule-open',
  templateUrl: './schedule-open.component.html',
  styleUrls: ['./schedule-open.component.css']
})
export class ScheduleOpenComponent {
  @ViewChild(SearchComponent) searchComponent: any;
  @ViewChild(BookingsExtendsComponent) BookingsExtendsComponent: any;
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;

  date_range: any = null;
  tour: any = null;
  items: any = [];

  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  constructor(private bookingService: BookingsService) {}

  init(param: any) {
    this.LoadingModalComponent.show();
    let val_params = 'search=' + this.params.search + '&page=' + this.page;
    this.bookingService.toursOpen(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
        this.LoadingModalComponent.hide();
      }
    });
  }

  detailBookingExtends(booking: any) {
    this.BookingsExtendsComponent.init(booking.booking_id);

  }

  afterBookingDetail(data: any) {}

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.init({});
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.init({});
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.init({});
  }

  close() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    setTimeout(() => {
      this.tour = null;
      this.items = [];
    }, 250);
  }
}
